import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import Divider from "@WhiteCap/Components/Basic/Divider";
import WhitecapColors from "@WhiteCap/Utils/WhiteCapColor";
import { FieldsProps } from "@WhiteCap/Widgets/Basic/SafetySystem";
import { FieldsPropsSuspensionSystem } from "@WhiteCap/Widgets/Basic/SuspensionSystem";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    fields: FieldsProps | FieldsPropsSuspensionSystem;
}

export interface BasicListStyles {
    listGridContainer?: GridContainerProps;
    listGridItem?: GridItemProps;
    title?: TypographyProps;
    link?: LinkPresentationProps;
}

const basicListStyle: BasicListStyles = {
    listGridContainer: {
        css: css`
            padding: 20px;
        `,
    },
    listGridItem: {
        width: [12, 12, 4, 4, 4],
        css: css`
            padding-top: 3px;
            padding-bottom: 3px;
        `,
    },
    title: {
        css: css`
            font-size: 18px;
            font-weight: 500;
            text-transform: uppercase;
            letter-spacing: 1px;
        `,
    },
    link: {
        color: WhitecapColors.orangeLink,
        css: css`
            font-size: 14px;
            &:hover {
                text-decoration: underline;
                ${TypographyStyle} {
                    color: ${getColor("text.main")};
                }
            }
        `,
    },
};

const styles = basicListStyle;

const BasicList = ({ fields }: OwnProps) => {
    return (
        <StyledWrapper>
            <StyledWrapper>
                <Typography variant="h4" {...styles.title}>
                    {fields.title}
                </Typography>
                <Divider borderTop={`1px solid ${WhitecapColors.borderGray}`} />
                <Typography variant="p" size={14}>
                    {fields.desc}
                </Typography>
            </StyledWrapper>

            <GridContainer {...styles.listGridContainer}>
                {fields.categories.map(item => (
                    <GridItem {...styles.listGridItem}>
                        <Link href={`#${item.fields.name.replace(" ", "-")}`} {...styles.link}>
                            <Typography as="li">{item.fields.name}</Typography>
                        </Link>
                    </GridItem>
                ))}
            </GridContainer>
        </StyledWrapper>
    );
};

export default BasicList;
